var map = {
	"./birthday.webp": "f526",
	"./chair1.jpg.webp": "9565",
	"./chair2.jpg.webp": "cce5",
	"./chair3.jpg.webp": "6e64",
	"./cutlery.jpg.webp": "22de",
	"./dumbell.jpg.webp": "6a30",
	"./ffvii.webp": "10c5",
	"./ffvii.webp.webp": "10e7",
	"./graphicstablet.jpg.webp": "a07f",
	"./hades.jpg.webp": "d2be",
	"./kindness.jpg.webp": "111d",
	"./manifoldgarden.jpg.webp": "ceb0",
	"./microphone.jpg.webp": "14cf",
	"./microwave.jpg.webp": "ac7b",
	"./minidesktop.jpg.webp": "ffe3",
	"./nier.jpg.webp": "da71",
	"./octopath.jpg.webp": "18a8",
	"./ori.jpg.webp": "03e6",
	"./piano.jpg": "af9e",
	"./piano.jpg.webp": "b805",
	"./pizza.jfif.webp": "47f5",
	"./prayer.jpg": "f222",
	"./prayer.jpg.webp": "3a1b",
	"./printer.jpg.webp": "3cf5",
	"./table.jpg.webp": "c69f",
	"./udemy.png.webp": "fa47",
	"./ups.jpg.webp": "d0d1",
	"./weight.jpg.webp": "369f",
	"./xboxcontroller.jpg.webp": "ad06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5cbd";